import React, { useEffect, useState } from "react";
import { Button, Table } from "antd";
import {
  FilePdfOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";
import moment from "moment";

import ActionButtons from "../../ActionButtons/ActionButtons";
import { NavigationPath } from "../../../helpers/constants";

const ResponseSingle = ({ actions, state }) => {
  const { offerResponses } = state;
  const { offerRequestId } = useParams();

  const navigate = useNavigate();

  const [singleOfferResponses, setSingleOfferResponses] = useState([]);

  useEffect(() => {
    actions.getOfferResponses();
  }, []);

  useEffect(() => {
    const currentOfferResponses =
      offerResponses
        .find((offer) => offer.key === offerRequestId)
        ?.offerResponse.map((response) => ({
          ...response,
          key: response.id,
        })) || [];

    setSingleOfferResponses(currentOfferResponses);

    if (currentOfferResponses.length === 0) {
      navigate(NavigationPath.OFFER_RESPONSES_ROUTE);
    }
  }, [offerResponses, offerRequestId]);

  const [selectedOffer, setSelectedOffer] = useState(null);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedOffer(selectedRows);
    },
  };

  const navigateToDetails = () => {
    if (!selectedOffer) {
      return;
    }
    navigate(`/offer-response/${selectedOffer[0].key}`);
  };

  const handleDeleteOffer = () => {
    if (!selectedOffer) {
      return;
    }
    const offerIds = selectedOffer.map((offer) => offer.key);
    actions.deleteSingleOfferResponse(offerIds);
    setSelectedOffer(null);
  };

  const pdfExport = () => {
    if (!offerRequestId) {
      return;
    }
    actions.exportPdf(offerRequestId);
  };

  const columns = [
    {
      title: "OSIGURAVAJUĆE DRUŠTVO",
      dataIndex: ["insurance", "name"],
    },
    {
      title: <div className="text-center">Ocjena</div>,
      width: 130,
      render: (record) => (
        <div className="text-center">
          {record.correct ? (
            <CheckCircleOutlined className="text-estimate-success text-base" />
          ) : (
            <CloseCircleOutlined className="text-estimate-fail text-base" />
          )}
        </div>
      ),
    },
    {
      title: "Datum zadnje izmjene",
      dataIndex: "updatedAt",
      responsive: ["md"],
      width: 190,
      render: (text) => moment(text).format("YYYY-MM-DD HH:mm:ss"),
      sorter: (a, b) => moment(a.updatedAt).diff(moment(b.updatedAt)),
    },
  ];

  return (
    <div className="p-4">
      <div className="sm:flex justify-between mb-4">
        <ActionButtons
          navigateToDetails={navigateToDetails}
          handleDelete={handleDeleteOffer}
          selectedUser={selectedOffer}
        />

        <Button
          onClick={pdfExport}
          icon={<FilePdfOutlined />}
          htmlType="button"
          className="bg-estimate-success border-estimate-success text-white px-2 text-center rounded-sm mr-4 mt-3 sm:mt-0"
        >
          IZVEZI U PDF
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={singleOfferResponses}
        rowSelection={{
          ...rowSelection,
        }}
      />
    </div>
  );
};

export default ResponseSingle;
